export const MINIMUM_ANALYTICS_SAMPLE = 20;

export const METRIC_REGISTRY = Object.freeze([
  {
    key: "assessment_started_count",
    name: "Assessments started",
    description: "Synthetic assessment records created during the selected period.",
    numerator: "assessment records with a start time",
    denominator: null,
    unit: "count",
    comparison: "period_over_period",
    minimumSample: 1,
    calculationVersion: "lab-r1.0",
    alertThreshold: null,
  },
  {
    key: "assessment_completion_rate",
    name: "Assessment completion",
    description: "Completed synthetic assessments divided by synthetic assessments started.",
    numerator: "assessment completed",
    denominator: "assessment started",
    unit: "rate",
    comparison: "period_over_period",
    minimumSample: MINIMUM_ANALYTICS_SAMPLE,
    calculationVersion: "lab-r1.0",
    alertThreshold: 0.05,
  },
  {
    key: "intervention_completion_rate",
    name: "Intervention completion",
    description: "Completed synthetic interventions divided by assigned interventions.",
    numerator: "intervention completed",
    denominator: "intervention assigned",
    unit: "rate",
    comparison: "period_over_period",
    minimumSample: MINIMUM_ANALYTICS_SAMPLE,
    calculationVersion: "lab-r1.0",
    alertThreshold: 0.06,
  },
  {
    key: "follow_up_completion_rate",
    name: "Follow-up completion",
    description: "Completed synthetic follow-ups divided by requested follow-ups.",
    numerator: "follow-up completed",
    denominator: "follow-up requested",
    unit: "rate",
    comparison: "period_over_period",
    minimumSample: MINIMUM_ANALYTICS_SAMPLE,
    calculationVersion: "lab-r1.0",
    alertThreshold: 0.06,
  },
  {
    key: "positive_response_rate",
    name: "Positive response association",
    description:
      "Synthetic follow-ups with a positive response divided by completed synthetic follow-ups. This is an association, not an effectiveness claim.",
    numerator: "positive follow-up response",
    denominator: "completed follow-up",
    unit: "rate",
    comparison: "period_over_period",
    minimumSample: MINIMUM_ANALYTICS_SAMPLE,
    calculationVersion: "lab-r1.0",
    alertThreshold: 0.07,
  },
  {
    key: "average_response_change",
    name: "Average response change",
    description:
      "Average synthetic post-response score minus synthetic pre-response score among completed follow-ups.",
    numerator: "sum of individual response changes",
    denominator: "completed follow-ups with comparable scores",
    unit: "points",
    comparison: "period_over_period",
    minimumSample: MINIMUM_ANALYTICS_SAMPLE,
    calculationVersion: "lab-r1.0",
    alertThreshold: 0.2,
  },
]);

export const metricDefinition = (key) =>
  METRIC_REGISTRY.find((metric) => metric.key === key) || null;

export const formatMetricValue = (metric, value) => {
  if (!Number.isFinite(value)) return "—";
  if (metric?.unit === "rate") return `${Math.round(value * 100)}%`;
  if (metric?.unit === "points") return `${value >= 0 ? "+" : ""}${value.toFixed(2)}`;
  return Math.round(value).toLocaleString();
};

export const formatMetricDelta = (metric, value) => {
  if (!Number.isFinite(value)) return "—";
  if (metric?.unit === "rate") {
    const points = value * 100;
    return `${points >= 0 ? "+" : ""}${points.toFixed(1)} pts`;
  }
  if (metric?.unit === "points") {
    return `${value >= 0 ? "+" : ""}${value.toFixed(2)}`;
  }
  return `${value >= 0 ? "+" : ""}${Math.round(value)}`;
};

